import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople, IoMdCheckbox } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import { MdCheckCircle, MdHome, MdLightMode, MdLocationPin, MdSearch } from "react-icons/md";

import OneObjective from "./OneObjective";

import banner1 from '../assets/banner2.jpg';
import banner2 from '../assets/banner2.jpg';
import banner3 from '../assets/banner3.jpg';
import banner4 from '../assets/banner4.jpg';
import banner5 from '../assets/banner5.jpg';
import banner6 from '../assets/banner6.jpg';
import banner7 from '../assets/banner7.jpg';
import bg from '../assets/bg.jpg';
import logo from '../assets/logo.png';

export default function AboutUsContent(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);
	const [ bgIndex, setBgIndex ] = useState(0);
	const banners = [banner5, banner7, banner1, banner2, banner3, banner4, ];

	async function init() {
		//run initializations here
		setReady(false);
		//..
		
		setReady(true);
	}


	

	useEffect(() => {
		init();
	}, [ ])

	useEffect(() => {
		if (!ready) return;

		const interval = setInterval(() => {
			setBgIndex(prev => (prev + 1) % banners.length);
		}, 2500); // change every 5 seconds

		return () => clearInterval(interval);
	}, [ready]);

	if(ready) {
		return (
			<div 
				className="MainBodySection"
				style={{
				}}
			>

					<div
						style={{
							backgroundImage: `url(${banner1})`,
							backgroundSize: 'cover',
							backgroundPosition: 'center',
							backgroundRepeat: 'no-repeat',
							height: '30vh',
						}}
					>
						<div
						>
							<h1 className="text-light text-center py-3 font-bold">ABOUT US</h1>
						</div>
					</div>
					<div className="bg-secondary p-5">
						<h6>
							Fimacy Company Limited was found on March, 2019 and incorporated on 21st June, 2019 under a Certificate of Incorporation No. 139359380 issued in the United Republic of Tanzania under the Company's Act of year 2002. The company began as a small venture company supporting IT, Telecoms & Network solutions for clients with small and medium enterprises based on client server environment. With a long term commitment to IT, Telecoms & Network industry, we have successfully established ourselves as a qualified and professional company which specializes in providing Infrastructure technical services and solutions including High Availability solutions, Security solutions, Internetworking &network infrastructure design, supporting Microsoft deployed solutions and IT based security.
							<br/><br/>
							Fimacy Company Limited prides in its founders and workforce who comprise highly skilled and well experienced University graduates of Tanzanian origin. These young professionals have excelled in their various fields of expertise and are geared to deliver up to standard services with keen attention to quality.
						</h6>
					</div>

				<div 
					className="MainBodySection" 
					style={{
						backgroundImage: `url(${bg})`,
						backgroundSize: 'cover',
						backgroundPosition: 'center',
						backgroundRepeat: 'no-repeat',
						overflow:"hidden"
					}}
				>
					<div 
						className="row pt-3 pb-5"
						
					>

						<div className="col-md-12 mt-5 px-5 text-center">
							<img src={logo} height={200}/>
						</div>

						<div className="col-md-12 mt-5 px-5">
														
							<h6
								style={{
									fontSize: "32px",
									textTransform: "uppercase"
								}}
								className="text-center text-secondary font-bold mt-3 mb-2"
							>
								OUR VISION
							</h6>

							<h6
								style={{
									fontSize: "16px",
								}}
								className="font-semi-bold text-center px-5"
							>
								To be the IT, Telecoms and Networks Enablement	Service Provider of choice.			
							</h6>
							
						</div>

						<div className="col-md-12 mt-5 px-5">
														
							<h6
								style={{
									fontSize: "32px",
									textTransform: "uppercase"
								}}
								className="text-center text-secondary font-bold mt-3 mb-2"
							>
								OUR MISSION
							</h6>

							<h6
								style={{
									fontSize: "16px",
								}}
								className="font-semi-bold text-center px-5"
							>
								To be the leader in IT, Telecoms and Network infrastructures service provision, through a focused range of services in Tanzania, delivering sustainable value to our customers whilst meeting shareholder requirements.
							</h6>
							
						</div>

						<div className="col-md-12 mt-5">
							<div 
								className="row p-5"
								style={{ display: "flex", alignItems: "stretch" }}
							>

								{/* LEFT COLUMN */}
								<div className="col-md-6 p-2 d-flex">
									<div className="bg-secondary p-5 rounded h-100 w-100">

										<h5 className="text-primary font-bold">
											Our Core Values
										</h5>

										<div className="d-flex gap-1 align-items-start mt-3">
											<IoMdCheckbox className="flex-shrink-0" color="#233520ff" size={24} />
											<h6>To refocus on the value we offer our customers</h6>
										</div>

										<div className="d-flex gap-1 align-items-start mt-3">
											<IoMdCheckbox className="flex-shrink-0" color="#233520ff" size={24} />
											<h6>To Increase Operations.</h6>
										</div>

										<div className="d-flex gap-1 align-items-start mt-3">
											<IoMdCheckbox className="flex-shrink-0" color="#233520ff" size={24} />
											<h6>To lead the Industry in creating value to our customers and scales channels</h6>
										</div>

									</div>
								</div>

								{/* RIGHT COLUMN */}
								<div className="col-md-6 p-2 d-flex">
									<div className="bg-primary p-5 rounded h-100 w-100">

										<h5 className="text-secondary font-bold">
											Our Philosophy
										</h5>

										<div className="mt-3 font-semi-bold">
											The philosophy of Company is to take the headache out of IT, Telecoms & Network Services Enablement. 
											We don't promise miracles, but we do promise that when something does go wrong it will be our problem 
											not yours. We aim to provide IT, Telecoms, and Network professionals with dependable tools that allow 
											them to focus on developing and maintaining the essential business processes that drive their 
											organizations, while we ensure service availability for our customers.
										</div>

									</div>
								</div>

							</div>
						</div>

					</div>
				</div>
			</div>
		)
	} else {
		return (
			<div 
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}

	
}